import Resource from './Resource'

class PortionTypeService extends Resource {
    async findAll() {
        const response = await this.axios.get(`portionTypes/`)
        return response.data
    }

    async findAllPhysicalPortionTypes() {
        const response = await this.axios.get(`portionTypes/physicalPortionTypes`)
        return response.data
    }
}
export default new PortionTypeService()

export const PORTION_TYPES = {
    FROZEN_BLOCK: { key: 'FROZEN_BLOCK', icon: 'icon-frozen-block' },
    VIRTUAL: { key: 'VIRTUAL', icon: 'icon-virtual-block' },
    PARAFFIN_BLOCK: { key: 'PARAFFIN_BLOCK', icon: 'icon-block' },
    ME_BLOCK: { key: 'ME_BLOCK', icon: '' },
    METHACRYLATE_BLOCK: { key: 'METHACRYLATE_BLOCK', icon: '' },
    CYTOLOGY_TUBE: { key: 'CYTOLOGY_TUBE', icon: '' },
    LIQUID_CYTOLOGY_TUBE: { key: 'LIQUID_CYTOLOGY_TUBE', icon: '' },
    STERILE_TUBE: { key: 'STERILE_TUBE', icon: '' }
}
